import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/BatteryFormationTestingHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-1.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

/* ─────────────────────────────────────────
   CSS — all classes prefixed .bft-
   Typography / spacing consistent with
   SoftwareInnovation (si-) page
───────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .bft { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .bft-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    
  }
  .bft-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right;
    display: block;
  }
  .bft-hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to right,
      rgba(0,0,0,0.85) 0%,
      rgba(0,0,0,0.65) 38%,
      rgba(0,0,0,0.10) 100%
    );
  }
  .bft-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .bft-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px;
    max-width: 520px;
  }
  .bft-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .bft-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .bft-breadcrumb {
    width: 100%; padding: 40px 0 0 0;
  }
  .bft-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto;
    padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .bft-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none;
    display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .bft-bc-item:hover { color: #EB2019; }
  .bft-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .bft-bc-sep img { width: 24px; height: 24px; display: block; }
  .bft-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER WRAPPER ══ */
  .bft-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
  }

  /* ══ MAIN SECTION ══ */
  .bft-main-section { padding: 80px 0 120px 0; }
  .bft-main-row {
    display: flex; align-items: flex-start; gap: 89px;
  }

  /* ══ ARTICLE ══ */
  .bft-article { flex: 1; min-width: 0; }

  /* Meta bar */
  .bft-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .bft-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right:1px solid #7A7A7A;
    padding-right:15px;
  }
    .bft-meta-item:last-child {
  border-right: none;
  padding-right: 0;
}
  .bft-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  /* Article title */
  .bft-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  /* Article image */
  .bft-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  /* Body text */
  .bft-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .bft-article-body p {
    margin-bottom: 15px;
  }
  .bft-article-body p:last-child { margin-bottom: 0; }

  /* Section headings */
  .bft-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%;
    display: block;
  }

  .bft-article-body strong { font-weight: 600; color: #202020; }

  .bft-red-link {
    color: #EB2019; text-decoration: underline;
  }
  .bft-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .bft-bottom-row {
    display: flex; align-items: center;
    justify-content: space-between;
    margin-top: 30px; padding-top:30px;
    border-top: 1px solid #C7C7C7;
    flex-wrap: wrap; gap: 16px;
  }
  .bft-prev-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .bft-prev-btn:hover { color: #EB2019; }
  .bft-prev-btn img { width: 40px; height: 40px; display: block; }

  .bft-share-icons {
    display: flex; align-items: center; gap: 20px;
  }
  .bft-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0;
    transition: opacity 0.15s;
  }
  .bft-share-icon:hover { opacity: 0.85; }
  .bft-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .bft-sidebar { flex: 0 0 475px; }

  .bft-sidebar-block { margin-bottom: 60px; }

  .bft-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }

  /* Recent posts */
  .bft-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .bft-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .bft-recent-item:hover .bft-recent-title { color: #EB2019; }
  .bft-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .bft-recent-body { flex: 1; min-width: 0; }
  .bft-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }

  /* Social icons */
  .bft-social-icons { display: flex; align-items: center; gap: 30px; margin-top: 0px; }
  .bft-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .bft-social-icon:hover { opacity: 0.8; }
  .bft-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .bft-hero             { height: 350px; }
    .bft-hero-content     { padding: 0 32px; }
    .bft-hero-title       { font-size: 30px; }
    .bft-hero-divider     { width: 100%; max-width: 479px; }
    .bft-breadcrumb       { padding: 24px 0 0 0; }
    .bft-breadcrumb-inner { padding: 0 32px; }
    .bft-inner            { padding: 0 32px; }
    .bft-main-section     { padding: 48px 0 60px 0; }
    .bft-main-row         { flex-direction: column; gap: 48px; }
    .bft-sidebar          { flex: none; width: 100%; }
    .bft-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .bft-hero             { height: 360px; }
    .bft-hero-content     { padding: 0 16px; }
    .bft-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .bft-hero-divider     { width: 100%; }
    .bft-hero-subtitle    { font-size: 14px; }
    .bft-breadcrumb       { padding: 30px 0 0 0; }
    .bft-breadcrumb-inner { padding: 0 16px; }
    .bft-bc-item          { font-size: 14px; gap: 14px; }
    .bft-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .bft-bc-sep img { width: 22px; height: 22px;}
    .bft-inner            { padding: 0 16px; }
    .bft-main-section     { padding: 30px 0 60px 0; }
    .bft-main-row         { flex-direction: column; gap: 60px; }
    .bft-sidebar          { flex: none; width: 100%; }
    .bft-article-title    { font-size: 20px; margin-bottom: 15px; }
    .bft-article-body     { font-size: 14px; }
    .bft-meta-item        { font-size: 14px; }
    .bft-article-img {     margin: 25px 0 30px 0; height: 250px;}
     .bft-h2 { font-size: 14px;     margin: 15px 0 15px 0;}
     .bft-prev-btn img { width: 24px;height:24px;}
     .bft-prev-btn { font-size: 14px;}
     .bft-share-icon img { width: 34px;height:34px;}
  }
`;

/* ── Recent posts data ── */
const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-guide/",
  },
];

/* ─────────────────────────────────────────
   COMPONENT
───────────────────────────────────────── */
export default function BatteryFormationTesting() {
  return (
    <div className="bft">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="bft-hero">
        <img className="bft-hero-bg" src={HeroBgImg} alt="Battery Formation Hero" />
        <div className="bft-hero-overlay" />
        <div className="bft-hero-content">
          <h1 className="bft-hero-title">
            Battery Formation &amp; Testing: Enabling The Rise Of EV &amp; Energy Storage Manufacturing
          </h1>
          <hr className="bft-hero-divider" />
          <p className="bft-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="bft-breadcrumb" aria-label="Breadcrumb">
        <div className="bft-breadcrumb-inner">
          <a href="/" className="bft-bc-item">Home</a>
          <span className="bft-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="bft-bc-item">News &amp; Updates</a>
          <span className="bft-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="bft-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="bft-main-section">
        <div className="bft-inner">
          <div className="bft-main-row">

            {/* ── ARTICLE ── */}
            <article className="bft-article">

              {/* Meta bar */}
              <div className="bft-meta-bar">
                <span className="bft-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="bft-meta-item"><img src={CalendarIcon} alt="date" /> July 17, 2025</span>
                <span className="bft-meta-item"><img src={ClockIconImg} alt="time" /> 6:39 am</span>
                <span className="bft-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="bft-article-title">
                Battery Formation &amp; Testing: Enabling the Rise of EV &amp; Energy Storage Manufacturing
              </h1>

              {/* Body */}
              <div className="bft-article-body">

                <p>What keeps electric vehicles (EVs) on the road and large energy storage systems running smoothly? Do you have any information on this aspect? It's not just about cutting-edge designs or sleek dashboards. The true magic frequently occurs during battery testing and formation, behind the scenes.</p>

                <p>India's EV market is expanding even faster as the nation advances smart city mobility enforcement and updates to traffic enforcement VNS technologies. The IESA 2024 projects that government measures, rising prices, and increased environmental awareness will drive India's EV battery demand to 50 GWh by 2027.</p>

                {/* Article image */}
                <img className="bft-article-img" src={ArticleImg} alt="Battery Formation Testing Equipment" />

                <p>To encounter this growing need, manufacturers must deliver millions of batteries that are both trustworthy and secure. That's where advanced battery formation and testing systems come in. In this article, let's break down how battery formation and testing play a crucial role in the rise of EV and energy storage manufacturing.</p>

                <p><strong>Let's dive in!</strong></p>

                <span className="bft-h2">1.  Why Does Precision Matter in Battery Formation?</span>

                <p>Battery formation is the first step, where the cells achieve their actual capacity through a technical process. This determines the reliability of your EV in taking you on a 300 km trip without an unexpected breakdown.</p>

                <p>Today's technology is utilized in smart city mobility enforcement in India, and traffic enforcement VMS solutions track every detail in real time. According to a 2024 industry report by BloombergNEF, over 95% of leading EV battery makers now utilize automated, data-driven formation systems to identify issues early and enhance consistency across thousands of cells.</p>

                <span className="bft-h2"> 2.  Extensive Testing to Complete Global Safety Norms</span>

                <p>Battery testing involves a rigorous process and requires proper handling. It covers capacity, internal resistance, cycle life, and other critical parameters. Manufacturers operate on cutting-edge testing infrastructure to comply with international regulations and standards. This includes dynamic testing stations that can simulate real-world conditions, whether an EV speeding through traffic guided by traffic enforcement VMS solutions or energy storage systems handling peak demand.</p>

                <p>This testing ensures that batteries won't fail under pressure, temperature deviations, or repeated charge/discharge cycles, thus supporting safer EV adoption and grid reliability.</p>

                <span className="bft-h2"> 3. Enabling High-Volume Production with Intelligent Automation</span>

                <p>Battery producers are increasing production from hundreds to millions of cells in response to the spike in demand. Inspired by the frameworks for smart city mobility enforcement in India, intelligent automation has become crucial.</p>

                <p>Modern battery formation and testing systems integrate Industrial IoT (IIoT), machine learning, and cloud analytics to streamline production. Automated systems can handle tasks like cell sorting, alignment, real-time monitoring, and reporting.</p>

                <p>By adopting automation similar to the approach used in traffic enforcement VMS solutions, manufacturers achieve growth across large production lines.</p>

                <span className="bft-h2"> 4. Sustainable Production with Energy Efficiency</span>

                <p>EVs and storage batteries promise a better future, but sustainable production is also necessary. Today's state-of-the-art battery formation systems are designed to ingest less power, recover heat, and optimize energy usage.</p>

                <p>Energy-efficient rectifiers, regenerative systems, and modular power supplies let manufacturers scale up while minimizing their carbon footprint. These endeavors align with India's national drive for sustainability and creative metropolitan growth, where eco-friendly infrastructure is combined with intelligent city mobility enforcement.</p>

                <p>Companies like <strong>Ador Powertron</strong> offer power electronics solutions that not only enhance battery quality but also reduce energy consumption, supporting a truly sustainable EV ecosystem.</p>

                <span className="bft-h2"> 5. Future-Ready Systems for Next-Gen Battery Chemistries</span>

                <p>From lithium-ion batteries to solid-state batteries and beyond, battery technologies are developing quickly. Modern formation and testing equipment must adapt to new chemistries and cell formats.</p>

                <p>This adaptability ensures manufacturers can switch to newer battery technologies without complete retooling. It's a forward-thinking strategy, comparable to traffic enforcement VMSs, that can change to accommodate new urban transportation regulations.</p>

                <span className="bft-h2">Wrapping Up</span>

                <p>The synergy between advanced manufacturing technologies and urban transformation is evident. Just as traffic enforcement VMS solutions and smart city mobility enforcement in India are reshaping cityscapes, sophisticated battery formation and testing systems are redefining what powers these cities.</p>

                <p>Trustworthy, high-quality batteries are the spine of EVs, renewable energy systems, and smart grids. They are the core, literally. The progress in building and testing is enabling manufacturers to provide safer, longer-lasting batteries that fulfill the rising need.</p>

                <p>Whether it's a scooter navigating traffic lights or a grid storing solar power for evening use, it all starts with precision-engineered batteries formed and tested to perfection.</p>

                <p>Explore our solutions and discover how <a href="/contact" className="bft-red-link">we can</a> help you shape the future of clean mobility and intelligent energy.</p>

                <p><a href="/contact" className="bft-red-link">Contact us</a> &nbsp;now!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="bft-bottom-row">
                <a href="/news/next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/" className="bft-prev-btn">
                  <img src={PreviousIcon} alt="Previous" />
                  Previous
                </a>
                <div className="bft-share-icons">
                 <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/" className="eai-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                   <a href="https://x.com/intent/tweet?text=%20https://adorpowertron.com/battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/" className="eai-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                    <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fbattery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing%2F%26title%3DBattery%2520Testing%2520%2526%2520Formation%2520Powering%2520India%25E2%2580%2599s%2520EV%2520Future%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fbattery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing%2F" className="eai-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="bft-sidebar">

              {/* Recent Posts */}
              <div className="bft-sidebar-block">
                <p className="bft-sidebar-title">Recent Posts</p>
                <div className="bft-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="bft-recent-item">
                      <img src={post.img} alt={post.title} className="bft-recent-img" />
                      <div className="bft-recent-body">
                        <span className="bft-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="bft-sidebar-block">
                <p className="bft-sidebar-title">Social Media</p>
                <div className="bft-social-icons">
                  <a href="https://adorpowertron.com/news/7/" className="bft-social-icon" target="blank" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F"  target="blank" className="bft-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}